import React from 'react';
import PropTypes from 'prop-types';
import { FormInput } from '@ami/react/core';
import { QuoteGroup } from '../quote-groups/quoteGroup';
import { FormDropdown } from '@ami/react/core';
import { DealerGroupsAsyncDropdown } from '../dealer-groups/DealerGroupsAsyncDropdown';
import { dealerUserService } from '../dealer-users/dealerUserService';
import { DealerUserFilter } from '../dealer-users/dealerUserFilter';

export class QuoteGroupData extends React.Component {
  constructor(props) {
    super(props);
    this.updateEntity = this.updateEntity.bind(this);
    this.state = { dealerUsers: [], isModal: false };
  }
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteGroup).isRequired,
    onUpdate: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
  };

  async componentDidMount() {
    const { entity } = this.props;
    if (entity.dealerGroupId && entity.dealerContactId !== '') {
      this.setState({ isModal: true });
      await this.LoadDealerUsers(entity.dealerGroupId);
    }
  }

  onUpdateInternal(entity) {
    this.props.onUpdate(new QuoteGroup({ ...entity }));
  }

  updateEntity(e) {
    this.onUpdateInternal({
      ...this.props.entity,
      [e.target.id]: e.target.value,
    });
  }

  async onAssignedToDealerGroupIdChange(dealerGroup) {
    var entity = this.props.entity;
    entity.dealerGroupId = dealerGroup ? dealerGroup.id : null;
    entity.dealerGroupName = dealerGroup ? dealerGroup.label : null;

    if (dealerGroup && dealerGroup.id && dealerGroup.id !== '') {
      await this.LoadDealerUsers(dealerGroup.id);
    }

    this.onUpdateInternal(entity);
  }

  async LoadDealerUsers(dealerGroupId) {
    var dealerUsers = [];
    if (dealerGroupId && dealerGroupId !== '') {
      dealerUsers = await dealerUserService.search(
        new DealerUserFilter({ dealerGroupId: dealerGroupId })
      );
    }
    this.setState({ dealerUsers });
  }

  onAssignedToDealerContactIdChange(id) {
    var entity = this.props.entity;
    entity.dealerContactId = id;
    this.onUpdateInternal(entity);
  }

  render() {
    const { entity, disabled } = this.props;

    const { dealerUsers, isModal } = this.state;

    return (
      <fieldset disabled={disabled}>
        <div>
          <div>
            <FormInput
              id="name"
              label="Name"
              value={entity.name}
              onChange={this.updateEntity}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">Dealer Group</label>
            <DealerGroupsAsyncDropdown
              label="Dealer Group"
              placeholder="All"
              onChange={(group) => this.onAssignedToDealerGroupIdChange(group)}
              selected={
                entity.dealerGroupId
                  ? {
                      id: entity.dealerGroupId,
                      label: entity.dealerGroupName,
                    }
                  : null
              }
              required
              readOnly={isModal}
            />
          </div>
          <div>
            <FormDropdown
              placeholder="Select an dealer contact..."
              label="Dealer Contact"
              items={dealerUsers}
              selectedId={entity.dealerContactId}
              onChange={(e) => this.onAssignedToDealerContactIdChange(e)}
              isClearable={true}
              required
            />
          </div>
        </div>
      </fieldset>
    );
  }
}
